import {SET_CURRENT_USER, SET_SPINNER} from '../actions/types';
import isEmpty from '../../validation/isEmpty';

const initialState = {
  isAuthenticated: false,
  isWorking: false,
  user: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_CURRENT_USER:
      return {
        ...state,
        isAuthenticated: !isEmpty (action.payload),
        user: action.payload,
      };
    case SET_SPINNER:
      return {
        ...state,
        isWorking: action.payload,
      };
    default:
      return state;
  }
}
